import request from '@/utils/request'

// 生存环境


// 上传EXCEL
export function batchExpertInit(data) {
  return request({
    data: data,
    url: '/old/batchExpertInit',
    method: 'post'
  })
}
// 任务列表获取
export function batchExpertOrder(data) {
  return request({
    data: data,
    url: '/old/batchExpertOrder',
    method: 'post'
  })
}

//3.	任务明细获取
export function batchExpertExpert(data) {
  return request({
    data: data,
    url: '/old/batchExpertExpert',
    method: 'post'
  })
}

//   4.	任务资源处理情况获取
export function batchExpertResource(data) {
  return request({
    data: data,
    url: '/old/batchExpertResource',
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/batch.js